import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    public logView: boolean = true; // true显示提示组件，false显示编辑组件
    public editView: boolean = false; // true显示修改，false显示新增
    public departmentQuery: any;
    public departmentInfo: any = {};
    public companyInfo: any;
    public treeDate: any;
    public parentId: string;
    public noteWord: string = '';
    public deleteVisible: boolean = false;
    public deleteId: string = '';
    public deleteName: string = '';
    public refreshEdit: boolean = true;
    public parentAvailables: Array<any> = [];
}


// WEBPACK FOOTER //
// ./src/display/platform/Organization/Modules.State.ts